"use client";

import Navbar from "./Navbar";

/** Navbar sticky (dentro do fluxo) para páginas internas e legadas. */
export default function NavbarFlow() {
  return <Navbar variant="flow" />;
}
